import { Routes, Route, Navigate } from 'react-router'
import { MainLayout } from '@/layouts/InfraMainLayout'
import { InfraDashboardPage } from '@/features/dashboard/InfraDashboardPage'
import { EnvironmentsPage } from '@/features/environment/InfraEnvironmentsPage'
import { EnvironmentDetailPage } from '@/features/environment/InfraEnvironmentDetailPage'
import { OnboardingWizardPage } from '@/features/environment/InfraOnboardingWizardPage'
import { OperationsPage } from '@/features/operation/InfraOperationsPage'
import { ImagesPage } from '@/features/image/InfraImagesPage'
import { ImageDetailPage } from '@/features/image/InfraImageDetailPage'
import { CredentialsPage } from '@/features/secondary/InfraCredentialsPage'
import { SSHKeysPage } from '@/features/secondary/InfraSSHKeysPage'
import { DNSPage } from '@/features/secondary/InfraDNSPage'
import { BackupsPage } from '@/features/secondary/InfraBackupsPage'
import { CostsPage } from '@/features/cost/InfraCostsPage'
import { CompliancePage } from '@/features/secondary/InfraCompliancePage'
import { UpdatesPage } from '@/features/secondary/InfraUpdatesPage'
import { IncidentTimelinePage } from '@/features/secondary/InfraIncidentTimelinePage'
import { ChartsPage } from '@/features/chart/InfraChartsPage'
import { TerraformModulesPage } from '@/features/terraform/InfraTerraformModulesPage'
import { AuditPage } from '@/features/audit/InfraAuditPage'
import { OIDCClientsPage } from '@/features/oidc/InfraOIDCClientsPage'
import { AccessDeniedPage } from '@/features/secondary/InfraAccessDeniedPage'
import { HostLogsPage } from '@/features/agent-host/InfraHostLogsPage'
import { RequirePlatformAdmin } from '@/components/auth/RequirePlatformAdmin'
import { InfraRolloutControlsPage } from '@/features/rollout/InfraRolloutControlsPage'
import { InfraHostsListPage, InfraHostDetailPage, InfraAlertsPage, InfraAlertDetailPage } from '@/features/monitoring'

export function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<InfraDashboardPage />} />
        <Route path="/environments" element={<EnvironmentsPage />} />
        <Route path="/environments/:id" element={<EnvironmentDetailPage />} />
        <Route path="/environments/new" element={<OnboardingWizardPage />} />
        <Route path="/operations" element={<OperationsPage />} />
        <Route path="/operations/:id" element={<OperationsPage />} />
        <Route path="/images" element={<ImagesPage />} />
        <Route path="/images/:id" element={<ImageDetailPage />} />
        <Route path="/charts" element={<ChartsPage />} />
        <Route path="/terraform-modules" element={<TerraformModulesPage />} />
        {/* Deployments removed — environment is the aggregate. Redirect stale bookmarks. */}
        <Route path="/deployments" element={<Navigate to="/environments" replace />} />
        <Route path="/deployments/:id" element={<Navigate to="/environments" replace />} />
        <Route path="/credentials" element={<CredentialsPage />} />
        <Route path="/ssh-keys" element={<SSHKeysPage />} />
        <Route path="/dns" element={<DNSPage />} />
        <Route path="/backups" element={<BackupsPage />} />
        <Route path="/costs" element={<CostsPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/updates" element={<UpdatesPage />} />
        <Route path="/incidents" element={<IncidentTimelinePage />} />
        <Route path="/oidc-clients" element={<OIDCClientsPage />} />
        <Route path="/agent-hosts/:id/logs" element={<HostLogsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        {/* Edge Host Monitoring (#670) — platform_admin-gated */}
        <Route path="/hosts" element={<RequirePlatformAdmin><InfraHostsListPage /></RequirePlatformAdmin>} />
        <Route path="/hosts/:id" element={<RequirePlatformAdmin><InfraHostDetailPage /></RequirePlatformAdmin>} />
        <Route path="/alerts" element={<RequirePlatformAdmin><InfraAlertsPage /></RequirePlatformAdmin>} />
        <Route path="/alerts/:fingerprint" element={<RequirePlatformAdmin><InfraAlertDetailPage /></RequirePlatformAdmin>} />
        <Route path="/rollout-controls" element={<RequirePlatformAdmin><InfraRolloutControlsPage /></RequirePlatformAdmin>} />
        <Route path="/access-denied" element={<AccessDeniedPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
